module.exports = __webpack_public_path__ + "img/GAME_COUNTCHICKS2.0db84399.jpg";